module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('h4', [_vm._v("1. Select at least 3 words to use in your password")]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-light border-dark",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.refreshWordlist()
      }
    }
  }, [_vm._v("Refresh Wordlist")])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.wordListFilled) ? _c('table', {
    staticClass: "table table-bordered table-striped hoverPointerTDs"
  }, [_c('tbody', _vm._l((5), function(row) {
    return _c('tr', _vm._l((3), function(col) {
      return _c('td', {
        key: col,
        class: {
          'selected-word': _vm.wordsSelected[row - 1][col - 1]
        },
        on: {
          "click": function($event) {
            return _vm.selectWord(row, col)
          }
        }
      }, [_vm._v(_vm._s(_vm.wordList2D[row - 1][col - 1]))])
    }), 0)
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('h4', [_vm._v("2. Generate your password")]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-light border-dark",
    attrs: {
      "disabled": _vm.generateButtonDisabled
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.generatePassword()
      }
    }
  }, [_vm._v("Generate")])]), _vm._v(" "), _c('br'), _vm._v("\n      After you've finished selecting your words, click generate until you find a password you like.\n    "), _vm._l((_vm.generatedPasswords.entries()), function(ref) {
    var index = ref[0];
    var password = ref[1];

    return _c('copy-paste-input', {
      key: index,
      attrs: {
        "text": password,
        "value": password,
        "show-check": _vm.clickedCopyInput === index
      },
      on: {
        "click": function($event) {
          return _vm.passwordSelected(password, index)
        }
      }
    })
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('h4', [_vm._v("3. Choose a password")]), _vm._v(" "), (_vm.genericMessage) ? _c('span', [_vm._v("Pick a password from the list above and then either copy or type it in as your new password wherever you would like.")]) : _vm._e(), _vm._v(" "), (!_vm.genericMessage) ? _c('span', [_vm._v("Pick a password from the list above and copy or type it in the \"" + _vm._s(_vm.passwordLabel) + "\" field below.")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37e609ed","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PasswordGenerator.vue
// module id = 1317
// module chunks = 16